import { biocharPartnersURL } from "@/config/api-config";

const biocharPartners = {
  title: "Biochar Partners",
  url: biocharPartnersURL,
  opacity: 0.8,
  renderer: {
    type: "unique-value",
    field: "source",
    defaultSymbol: {
      type: "simple-marker",
      style: "triangle",
      color: "#f1c40f",
      size: 15,
      opacity: 0.8,
      outline: {
        color: "white",
        width: 0.5,
      },
    },
  },
  popupTemplate: {
    title: "{name}",
    content: [
      {
        type: "fields",
        fieldInfos: [
          {
            fieldName: "name",
            label: "Biochar Partner Name",
          },
          {
            fieldName: "biomassType",
            label: "Biomass Type",
          },
          {
            fieldName: "biomassWaste",
            label: "Biomass Waste",
          },
          {
            fieldName: "annualFeedstock",
            label: "Annual Feedstock (MT)",
          },
          {
            fieldName: "volumeCategory",
            label: "Volume Category",
          },
          {
            fieldName: "phoneNumber",
            label: "Contact",
          },
          {
            fieldName: "businessType",
            label: "Business Type",
          },
          {
            fieldName: "primaryCrop",
            label: "Primary Crop",
          },
          {
            fieldName: "wasteDisposalCost",
            label: "Waste Disposal Cost)",
          },
        ],
      },
    ],
  },
  visible: true,
//   legendEnabled: false,
};

export default biocharPartners;